import { ReactNode } from "react";

import diamondGold from "@/assets/diamond-gold@2x.png";
import diamondBronze from "@/assets/diamond-bronze@2x.png";
import diamondSilver from "@/assets/diamond-silver@2x.png";
import diamondOriginal from "@/assets/diamond-orginal@2x.png";

import Image, { StaticImageData } from "next/image";

export const iconDiamond = (points_tier: string, size: string): ReactNode => {
  let diamond: StaticImageData;
  let sizeImage: number;

  switch (points_tier) {
    case "BRONZE":
      diamond = diamondBronze;
      break;
    case "SILVER":
      diamond = diamondOriginal;
      break;
    case "GOLD":
      diamond = diamondGold;
      break;
    case "PLATINUM":
      diamond = diamondSilver;
      break;
    default:
      diamond = diamondBronze;
      break;
  }

  switch (size) {
    case "sm":
      sizeImage = 16;
      break;
    case "md":
      sizeImage = 18;
      break;
    case "lg":
    case "xl":
      sizeImage = 20;
    case "2xl":
      sizeImage = 22;
      break;
    default:
      sizeImage = 14;
      break;
  }

  return (
    <Image
      src={diamond}
      alt={`diamond-icons`}
      width={sizeImage}
      height={sizeImage}
      className="inline-block"
    />
  );
};
